/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ReadyInputs */

const cs_enum_ready = /** @type {(inputs: Enum_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno`)
};

const en_enum_ready = /** @type {(inputs: Enum_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Enum_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_ready = /** @type {((inputs?: Enum_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_ready(inputs)
	return cs_enum_ready(inputs)
});